export default __webpack_public_path__ + "receiveEmails.7972ba7833dd0a8017a8866c1a61edc8.png";